import { render, staticRenderFns } from "./rubric_preview_tab.vue?vue&type=template&id=6686253a&scoped=true&"
import script from "./rubric_preview_tab.vue?vue&type=script&lang=js&"
export * from "./rubric_preview_tab.vue?vue&type=script&lang=js&"
import style0 from "./rubric_preview_tab.vue?vue&type=style&index=0&id=6686253a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6686253a",
  null
  
)

export default component.exports